export default {
  setServiceDetails(state, data) {
    state.serviceDetails = data
  },
}
